<template>
  <footer
    class="app-build-footer"
    :title="buildInfo.titleText"
    aria-label="Application build information"
  >
    {{ buildInfo.footerText }}
  </footer>
</template>

<script setup>
import { computed } from 'vue';
import { readBuildInfo } from '@/utils/buildInfo.mjs';

const buildInfo = computed(() => readBuildInfo());
</script>

<style scoped>
.app-build-footer {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 30;
    padding: 0.25rem 0.75rem;
    font-size: 0.6875rem;
    line-height: 1.25rem;
    text-align: center;
    color: rgb(156 163 175);
    background: rgb(253 248 234 / 0.92);
    border-top: 1px solid rgb(229 231 235);
    pointer-events: none;
    user-select: none;
}
</style>
